import script from "./RecordList.vue?vue&type=script&setup=true&lang=js"
export * from "./RecordList.vue?vue&type=script&setup=true&lang=js"

import "./RecordList.vue?vue&type=style&index=0&id=00e490ef&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e490ef"]])

export default __exports__